module.exports = __webpack_public_path__ + "media/images/usage-coupon-4-9554170530d313b5e1b122f8b86a468d.png";